module.exports = __webpack_public_path__ + "img/ico-multi.3e9c0d85.svg";